import {
  CheckNotes,
  InspectionCase,
  InspectionZCoefficientCase,
  InspectionZCoefficientCaseDto
} from '../../inspection-cases';

export class DeploymentAgainstEarthquakesDto extends InspectionCase {
  deploymentAccordingSpec?: InspectionCase;
  pipingTypeAccordingSpec?: InspectionCase;
  zCoefficient?: InspectionZCoefficientCaseDto;
  calculationsAccordingSpec?: InspectionCase;
}

export class DeploymentAgainstEarthquakes extends DeploymentAgainstEarthquakesDto {
  constructor(
    data: DeploymentAgainstEarthquakesDto = {
      title:
        'פריסת המתזים / צנרת / אביזרי קצה / תמיכות וחיזוקים נגד רעידות אדמה'
    }
  ) {
    super(data);
    this.deploymentAccordingSpec = new InspectionCase({
      ...data.deploymentAccordingSpec,
      title: 'פריסת המתזים / אביזרי הקצה מתאימים לדרישות התקן'
    });
    this.pipingTypeAccordingSpec = new InspectionCase({
      ...data.pipingTypeAccordingSpec,
      title: 'סוג הצנרת מתאים לדרישות התקן'
    });
    this.zCoefficient = new InspectionZCoefficientCase({
      ...data.zCoefficient,
      title: 'מקדם Z'
      // notes:
      //   data.notes && data.zCoefficient.notes.length > 0
      //     ? data.zCoefficient.notes
      //     : [
      //         {
      //           addNotesToReport: true,
      //           notes: `ערכו של מקדם Z הוא: 0`
      //         }
      //       ]
    });
    this.calculationsAccordingSpec = new InspectionCase({
      ...data.calculationsAccordingSpec,
      title: 'בוצעו חישובים תוך התחשבות במקדם Z ומקדם חשיבות'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.deploymentAccordingSpec.isApplicable ||
        this.deploymentAccordingSpec.isPassed) &&
        (!this.pipingTypeAccordingSpec.isApplicable ||
          this.pipingTypeAccordingSpec.isPassed) &&
        (!this.zCoefficient.isApplicable || this.zCoefficient.isPassed) &&
        (!this.calculationsAccordingSpec.isApplicable ||
          this.calculationsAccordingSpec.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.deploymentAccordingSpec.getNotes(),
      ...this.pipingTypeAccordingSpec.getNotes(),
      ...this.zCoefficient.getNotes(),
      ...this.calculationsAccordingSpec.getNotes()
    ];
  }
}
